import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { resolveLandingPath } from '../utils/capabilities';

interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, isAgent } = useAuth();
  const location = useLocation();

  // Don't redirect while loading
  if (isLoading) {
    return <>{children}</>;
  }

  // Redirect authenticated users away from public routes like login — to the home page of their role
  if (isAuthenticated) {
    return <Navigate to={resolveLandingPath({ isAgent }, location.state?.from?.pathname)} replace />;
  }

  return <>{children}</>;
};

export default PublicRoute;
